import { ApplicationRef, Injector, NgModule } from "@angular/core";
import { ServiceLocator } from "@shared/registry/locator.service";
import player from 'lottie-web';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
    return player;
}


@NgModule()
export class AppModule {
    constructor(public appRef: ApplicationRef, injector: Injector) {
        ServiceLocator.injector = injector;
    }
}
